import { combineReducers } from 'redux'
import language from '../../../../common/reducers/language'
import login from "../../../../common/reducers/login"
import modal from "../../../../common/reducers/modal"

const rootReducer = combineReducers({
  login,
  language,
  modal
})
export default rootReducer
